<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ClientOnly>
      <LanguageSuggestionPopup />
    </ClientOnly>
    <ClientOnly>
      <CookieBanner />
      <ReconsentBanner />
      <SupportChatFab v-if="showSupportFab" :is-open="isChatOpen" @toggle="isChatOpen = !isChatOpen" />
      <SupportChatPanel v-if="isChatOpen" @close="isChatOpen = false" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, ref, computed } from 'vue';
import { useRoute } from '#imports';
import CookieBanner from '#components/consent/CookieBanner.vue';
import ReconsentBanner from '#components/consent/ReconsentBanner.vue';
import SupportChatFab from '#components/support/SupportChatFab.vue';

const SupportChatPanel = defineAsyncComponent(() => import('#components/support/SupportChatPanel.vue'));

const route = useRoute();
const showSupportFab = computed(() => !route.meta.hideSupportFab);

const isChatOpen = ref(false);
</script>
